import React, { useEffect } from 'react';
import DynamicTable from '../tables/DynamicTable';
import { ApiService } from '../../api/ProjectInfoService';
import { CircularProgress } from '@mui/joy';
import { toast } from 'react-toastify';
import DialogForm from './PartnerDialogForm';

interface PartnerBoxProps {
    title: string;
    project: any;
    dospId: string;
    email: string;
    userIsPrivileged: boolean;
}




const PartnerBox = ({ title, project, dospId,email,userIsPrivileged } : PartnerBoxProps) => {
    const [contactpersons, setContactpersons] = React.useState<any[]>([]);
    const [ accountTypes, setAccountTypes] = React.useState<any[]>([]);
    const [accounts, setAccounts] = React.useState<any[]>([]);
    const [memberTypes, setMemberTypes] = React.useState<any[]>([]);
    useEffect(() => {
        try {
          if (userIsPrivileged) {
            ApiService.getContactData().then((res) => {
              return setContactpersons(res.data.models);
            });
            ApiService.getAccountsData().then((res) => {
              return setAccounts(res.data.models);
            });
            ApiService.getAccountTypesOnly().then((res) => {
              return setAccountTypes(res.data);
            });
            // ApiService.getMemberTypes().then((res) => {
            //   return setMemberTypes(res.data);
            // });
          }
        } catch (error) {
            toast.error("Er is iets misgegaan tijdens het ophalen van de data");
        }
      }, []);
    const onSave = (data: any) => {
      toast.info("Aanvraag word verstuurd");
        const dataToSend = {

                id: data.account?.id,
                tradename: data.tradename,
                officialname: data.officialname,
                vatnumber: data.vatnumber,
                type: data.accountType?.optionValue,
                subtype: data.subtype,
                projectDospId: dospId,
                contactId: {
                  id: data.contact?.id,
                  firstname: data.firstname ? data.firstname : null,
                  lastname: data.lastname,
                  email: data.email,
                  language: null
                },
        };
        ApiService.postPartner(dataToSend).then((res) => {
          toast.success("Aanvraag is succesvol verzonden");
        });
      }
    
     // if (accounts.length === 0 || accountTypes.length === 0) {
     //   return (
     //     //loading spinner icon
     //     <div className="loadingCircle">
     //       <CircularProgress
     //         size="lg"
     //         sx={{ "--CircularProgress-trackColor": "#484494", '--CircularProgress-progressColor': '#b6b4d4' }}
     //       />
     //     </div>
     //   );
     // }

    
      
    return (
        <div className="box">
            <div className="headerLeden">
            <h2>{title}</h2>
            {userIsPrivileged && <DialogForm onSave={onSave} memberTypes={memberTypes} contactpersons={contactpersons} accountTypes={accountTypes.filter(a => a.isActive)} accounts={accounts.filter(a=> a.isActive)}/>}
            </div>
            <DynamicTable
            data={project?.partners?.models}
            columns={[
                {id: 2 ,label: "Aard", property:'kind.name'},
                {id: 5 ,label: "Accounttype", property:'type.name'},
                {id: 3 ,label: "Accountsubtype", property:'subType.name'},
                {id: 4,label: "Account", property:'account.name'},
                {id: 1 ,label: "Contact" ,property: "contact.name"},
                ]}
            />
        </div>
    );
};

export default PartnerBox;
